import { highArmorTokenColumn } from "../resource/high-armor-token-column";
import { NeededColumn } from "./needed-column";

export const highArmorTokenNeededColumn = new NeededColumn(
  "e169e941-f4fb-4bd4-b101-362d2c4541cf",
  highArmorTokenColumn,
  "HAT Needed"
)
